import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()

const JOB_PROFILE="talent_cloud/job_profile"
const JOB_PROFILE_ID=(id)=>`${JOB_PROFILE}/${id}`
const JOB_PROFILE_COMPETENCES=(id)=>`${JOB_PROFILE}/${id}/competences`
const JOB_PROFILE_COLABORADORES=(id)=>`${JOB_PROFILE_ID(id)}/colaboradores`
const JOB_PROFILE_KPIS=(id)=>`${JOB_PROFILE}/${id}/kpis`
const JOB_PROFILE_HISTORY=(id)=>`${JOB_PROFILE}/${id}/history`
const JOB_PROFILE_TOOLS=(id)=>`${JOB_PROFILE}/${id}/tools`
const JOB_PROFILE_INTERACCIONES=(id)=>`${JOB_PROFILE}/${id}/interacciones`
const JOB_PROFILE_SKILL=(id)=>`${JOB_PROFILE}/${id}/skill`
const JOB_PROFILE_RESPONSIBILITY=(id)=>`${JOB_PROFILE}/${id}/responsibility`
const JOB_PROFILE_SKILL_TYPE=`${JOB_PROFILE}/skill/type`

// JOB_PROFILE
export const jobProfileGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE,{params,signal:controller.signal})
    return {call,controller}
}
/**
 * @description Función para obtener un perfil puesto por id
 * @param { object } params Parámetros para la petición
 * @param {int} params.id Id del perfil puesto
 * @returns 
 */
export const jobProfileIdGet = ({id ,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(`${JOB_PROFILE}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileIdHistoryGet = ({id ,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_HISTORY(id),{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileIdDelete = (id ,params) => {
    
    const controller= loadAbort()
    const call= axios.delete(`${JOB_PROFILE}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}

/**
 * @description Función para obtener un perfil puesto por id
 * @param { object } params Parámetros para la petición
 * @param {int} params.id Id del perfil puesto
 * @returns 
 */
export const jobProfilePost = (data,params) => {
    
    const controller= loadAbort()
    const call= axios.post(`${JOB_PROFILE}`,data,{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfilePut = (id,data,params) => {
    
    const controller= loadAbort()
    const call= axios.put(`${JOB_PROFILE}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

// JOB_PROFILE_KPIS
export const jobProfileKpisGet = ({profileId,params}) => {
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_KPIS(profileId),{params,signal:controller.signal})
    return {call,controller}

}

export const jobProfileKpisPost = (id,data,params) => {
const controller= loadAbort()
const call= axios.post(JOB_PROFILE_KPIS(id),data,{params,signal:controller.signal})
return {call,controller}
}

export const jobProfileKpisDelete = (profileId,id,params) => {
const controller= loadAbort()
const call= axios.delete(`${JOB_PROFILE_KPIS(profileId)}/${id}`,{params,signal:controller.signal})
return {call,controller}
}

// JOB_PROFILE_COMPETENCES

/**
 * @description Trae las  evaluacion de competencia del perfil
 */

export const jobProfileIdCompetencesGet = ({profileId ,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_COMPETENCES(profileId),{params,signal:controller.signal})
    return {call,controller}
}
/**
 * @description Trae las  evaluacion de competencia del perfil
 */

export const jobProfileIdCompetencesPost = ({id,data ,params}) => {
    
    const controller= loadAbort()
    const call= axios.post(JOB_PROFILE_COMPETENCES(id),data,{params,signal:controller.signal})
    return {call,controller}
}

/**
 * @description Eliminar una evaluacion de competencia de perfil
 */
export const jobProfileCompetencesIdDelete = (profileId,id ,params) => {
    
    const controller= loadAbort()
    const call= axios.delete(`${JOB_PROFILE_COMPETENCES(profileId)}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}



// TOOLS
export const toolsGet = ({params}) => {
    
    const controller= loadAbort()
    const call= axios.get("talent_cloud/herramienta_trabajo",{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileToolsGet = ({profileId,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_TOOLS(profileId),{params,signal:controller.signal})
    return {call,controller}
}

export const jobProfileToolsPost = (profileId,data,params) => {
    
    const controller= loadAbort()
    const call= axios.post(JOB_PROFILE_TOOLS(profileId),data,{params,signal:controller.signal})
    return {call,controller}
}

export const jobProfileToolsDelete = (profileId,id,params) => {
    const controller= loadAbort()
    
    const call= axios.delete(`${JOB_PROFILE_TOOLS(profileId)}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}

// JOB_PROFILE_INTERACCIONES
export const jobProfileInteractionsGet = ({profileId,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_INTERACCIONES(profileId),{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileInteractionsPost = (profileId,data,params) => {
    const controller= loadAbort()
    
    const call= axios.post(JOB_PROFILE_INTERACCIONES(profileId),data,{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileInteractionsDelete = (profileId,id,params) => {
    const controller= loadAbort()
    
    const call= axios.delete(`${JOB_PROFILE_INTERACCIONES(profileId)}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}

// JOB_PROFILE_SKILL
export const jobProfileSkillTypeGet = (params) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_SKILL_TYPE,{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileSkillGet = ({profileId,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_SKILL(profileId),{params,signal:controller.signal})
    return {call,controller}
}
export const jobProfileSkillPost = (profileId,data,params) => {
    
    const controller= loadAbort()
    const call= axios.post(JOB_PROFILE_SKILL(profileId),data,{params,signal:controller.signal})
    return {call,controller}
}

export const jobProfileSkillDelete = (profileId,id,params) => {
    
    const controller= loadAbort()
    const call= axios.delete(`${JOB_PROFILE_SKILL(profileId)}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}


// JOB_PROFILE_RESPONSIBILITY

export const jobProfileResponsibilityGet = ({profileId,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_RESPONSIBILITY(profileId),{params,signal:controller.signal})
    return {call,controller}
}

export const jobProfileResponsibilityPost = (profileId,data,params) => {
    
    const controller= loadAbort()
    const call= axios.post(JOB_PROFILE_RESPONSIBILITY(profileId),data,{params,signal:controller.signal})
    return {call,controller}
}

export const jobProfileResponsibilityDelete = (profileId,id,params) => {
    
    const controller= loadAbort()
    const call= axios.delete(`${JOB_PROFILE_RESPONSIBILITY(profileId)}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}

// JOB_PROFILE_COLABORADORES
export const jobProfileColaboradoresGet = ({profileId,params}) => {
    
    const controller= loadAbort()
    const call= axios.get(JOB_PROFILE_COLABORADORES(profileId),{params,signal:controller.signal})
    return {call,controller}
}